// extracted by mini-css-extract-plugin
export default {"rootmap":"RootMap_rootmap__vDbf9"};